import type { OrderInterface, PageableContent } from '@/types'
import api from '@/utils/api/api'

import { serializeOrdersParams } from '../lib/ordersListParams'
import type { OrdersPageParams } from '../types/orders.types'

type RequestOptions = {
  signal?: AbortSignal
}

export type OrdersPage = PageableContent<OrderInterface['orderModel']>

type OrdersListResponse = { orders: OrdersPage }

export const ordersApi = {
  getOrders: async (params: OrdersPageParams, options?: RequestOptions) => {
    const { data } = await api.get<OrdersListResponse>('/orders', {
      params,
      paramsSerializer: serializeOrdersParams,
      signal: options?.signal,
    })
    return data.orders
  },
}
